var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "voiceMessage",
      staticClass: "sc-message--text",
      attrs: { id: "voiceMessagePlayer" },
    },
    [
      _vm.isGroupMessage
        ? _c(
            "span",
            {
              staticClass: "whatsapp-number-first",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  _vm.showWhatsappChatStarterModal = true
                },
              },
            },
            [
              _c(
                "a",
                {
                  style: { color: _vm.getWhatsappNumberColor() },
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _vm._v(
                    _vm._s(_vm.whatsappAuthorName) +
                      " - " +
                      _vm._s(_vm.whatsappAuthorNumber)
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "audio-player-container" },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.toggleAudio()
                },
              },
            },
            [
              _c("md-icon", { attrs: { id: "playButton" } }, [
                _vm._v(_vm._s(_vm.paused ? "play_circle" : "pause_circle")),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("av-waveform", {
            attrs: {
              id: "waveform",
              playtime: false,
              playtimeWithMs: false,
              playtimeTextBottom: false,
              playtimeSliderWidth: 3,
              noplayedLineColor: "#999999",
              "played-line-color": "#6098ff",
              "audio-src": _vm.getSrc(),
              playtimeFontSize: 0,
              canvWidth: 200,
              canvHeight: 40,
              "played-line-width": 0.3,
              "noplayed-line-width": 0.3,
              "playtime-slider-color": "#4E8CFF",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.data.transcribedText
        ? _c("div", { staticClass: "transcription-container" }, [
            _c(
              "div",
              {
                staticClass: "transcription-header",
                on: { click: _vm.toggleTranscription },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.showTranscription
                        ? "Transkripsiyonu Gizle"
                        : "Transkripsiyonu Göster"
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("md-icon", [
                  _vm._v(
                    _vm._s(
                      _vm.showTranscription ? "expand_less" : "expand_more"
                    )
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTranscription,
                    expression: "showTranscription",
                  },
                ],
                staticClass: "transcription-text",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.data.transcribedText) +
                    "\n        "
                ),
              ]
            ),
          ])
        : _c(
            "div",
            {
              staticClass: "transcribe-button",
              on: { click: _vm.requestTranscription },
            },
            [_c("a", { attrs: { href: "#" } }, [_vm._v("Transkripsiyon Yap")])]
          ),
      _vm._v(" "),
      _vm.isGroupMessage
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "justify-content": "end",
                "align-items": "center",
                padding: "0 0.3rem",
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "sc-message-meta-new whatsapp-number",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.showWhatsappChatStarterModal = true
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.getWhatsappNumberColor() },
                      attrs: { href: "javascript:void(0)" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.whatsappAuthorName) +
                          " - " +
                          _vm._s(_vm.whatsappAuthorNumber)
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWhatsappChatStarterModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.whatsappChatStart"),
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  _vm.showWhatsappChatStarterModal = false
                },
              },
            },
            [
              _c("WhatsappChatStarter", {
                attrs: {
                  "default-phone-number": _vm.whatsappAuthorNumber,
                  "channel-override": "",
                  "phone-number-override": "",
                  "default-name": _vm.whatsappAuthorName,
                },
                on: {
                  close: function ($event) {
                    _vm.showWhatsappChatStarterModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }